import axios from "axios";

// Function to make a GET request
export const getApi = async (endpoint, access_token, elem) => {
  return new Promise(async (resolve, reject) => {
    let config = {
      method: "GET",
      headers: access_token
        ? {
            Authorization: "Bearer " + access_token,
            Accept: "application/json",
          }
        : {},
      body: elem ? JSON.stringify(elem) : elem,
    };
    return await axios
      .get(endpoint, config)
      .then((response) => {
        return resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Function to make a POST request
export const postApi = async (endpoint, elem, access_token) => {
  return new Promise(async (resolve, reject) => {
    let config = {
      method: "POST",
      headers: access_token
        ? {
            Authorization: "Bearer " + access_token,
          }
        : { "Content-Type": "application/json" },
    };
    return await axios
      .post(endpoint, elem, config)
      .then((response) => {
        return resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Function to make a PATCH request
export const patchApi = async (endpoint, elem, access_token) => {
  return new Promise(async (resolve, reject) => {
    let config = {
      method: "PATCH",
      headers: access_token
        ? {
            Authorization: "Bearer " + access_token,
          }
        : { "Content-Type": "application/json" },
    };
    return await axios
      .patch(endpoint, elem, config)
      .then((response) => {
        return resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Function to make a DELETE request
export const deleteApi = async (endpoint, access_token) => {
  return new Promise(async (resolve, reject) => {
    let config = {
      method: "DELETE",
      headers: access_token
        ? {
            Authorization: "Bearer " + access_token,
          }
        : {},
    };
    return await axios
      .delete(endpoint, config)
      .then((response) => {
        return resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Function to make a PUT request
export const putApi = async (endpoint, data, access_token) => {
  return new Promise(async (resolve, reject) => {
    let config = {
      method: "PUT",
      headers: access_token
        ? {
            Authorization: "Bearer " + access_token,
          }
        : { "Content-Type": "application/json" },
    };
    try {
      const response = await axios.put(endpoint, data, config);
      resolve(response);
    } catch (err) {
      reject(err);
    }
  });
};
